import { ReactNode } from 'react'
// @ts-ignore
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

interface ScrollAreaProps {
  children?: ReactNode;
  maxHeight: number;
  className?: string;
}

export default function ScrollArea (props: ScrollAreaProps) {
  const { maxHeight = 180, className, children } = props

  return (
    <SimpleBar
      className={className}
      style={{ maxHeight, overflowX: 'hidden', willChange: 'auto' }}
    >
      {children}
    </SimpleBar>
  )
}
